import React from 'react';

const Modelo3dCardSkeleton = () => (
    <div className="rounded-lg shadow-md overflow-hidden h-56 animate-pulse">
        <div className="h-[80%] bg-base-200" />
        <div className="h-[20%] bg-base-300 px-4 flex items-center justify-center">
            <div className="h-3 bg-base-200 rounded w-2/3" />
        </div>
    </div>
);

export default Modelo3dCardSkeleton;
